import {
    AllGlossaryData,
    Alternativedata,
    GeneralPagesSEOData,
    Holidays2025data,
    WebStoriesdata
} from "./fetchjsonsdata";

type FAQSchemaProps = {
    faqs: { question: string; answer: string }[];
};

const generateFaqSchema = ({ faqs = [] }: FAQSchemaProps) => {
    if (!faqs.length) return null;

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(({ question, answer }) => ({
            "@type": "Question",
            "name": question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": answer,
            },
        })),
    };

    return [faqSchema];
};

const formatDate = (date) => new Date(date).setUTCHours(18, 30, 0, 0) && new Date(date).toISOString();

const PagejsonLd =
{
    "@context": "http://www.schema.org",
    "@type": "Organization",
    "name": "GetBiz Solutions",
    "url": "https://getbiz.solutions/",
    "sameAs": [
        "https://www.facebook.com/getbizsolutions",
        "https://www.youtube.com/@getbiz_solutions",
        "https://www.pinterest.com/getbiz_solutions",
        "https://www.linkedin.com/company/getbiz-solutions",
        "https://www.instagram.com/getbiz_solutions",
        "https://x.com/Getbiz_Solution",
    ],
    "description": "Discover GetBiz Solutions expert services in web design, website development, and digital marketing. Let us boost your online presence and business success.",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "537, 5 Square Point,",
        "postOfficeBoxNumber": "RANDER",
        "addressLocality": "Surat",
        "addressRegion": "Gujarat",
        "postalCode": "395005",
        "addressCountry": "India"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": "21.229726791381836",
        "longitude": "72.78727722167969"
    },
    "hasMap": "https://maps.app.goo.gl/Z9eH1vt8rjYeyHSz8",
    "openingHours": "Mo 08:00-21:00 Tu 08:00-21:00 We 08:00-21:00 Th 08:00-21:00 Fr 08:00-21:00 Sa 08:00-18:00"
};
var mdxdata = null;

export async function getSeoData(FullURL: string) {
    const segments = FullURL.split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1] || "";
    const cleanURL = FullURL.replace(/\/$/, "");
    const siteURL = process.env.NEXT_PUBLIC_BASE_URL;

    let seoData: any = null;

    // **Check GeneralPagesSEOData First**
    const generalMatch = GeneralPagesSEOData.find(
        page => page.page_title?.toLowerCase().replace(/\s+/g, "-") === (FullURL === "/" ? "home" : lastSegment)
    );

    if (generalMatch) {
        seoData = {
            seo_title: generalMatch.seo_title,
            seo_description: generalMatch.seo_description,
            seo_keyword: generalMatch.seo_keyword,
            og_image: siteURL + generalMatch.og_image,
            faq: generalMatch.faq,
            ld_json: PagejsonLd,
            additionalldjson: generalMatch.json_ld,
            created_date: generalMatch.created_date,
            updated_date: generalMatch.updated_date
        };
    }
    else if (FullURL.includes("/glossary/")) {
        const match = AllGlossaryData.find((item: any) => item.slug === lastSegment);

        if (match) {
            seoData = {
                seo_title: match.title + " - Getbiz Solutions Glossary",
                seo_description: match.description,
                seo_keyword: match.keywords.join(", "),
                faq: generateFaqSchema({ faqs: match.faqs }),
                og_image: siteURL + match.img,
                ld_json: PagejsonLd,
                created_date: match.created_date,
                updated_date: match.updated_date
            };
        }
    }
    else if (FullURL.includes("/web-stories/")) {
        const match = WebStoriesdata.find((item: any) => item.slug === lastSegment);
        if (match) {
            seoData = {
                seo_title: match.seo_title,
                seo_description: match.seo_description,
                seo_keyword: match.seo_keywords,
                og_image: siteURL + match.image,
                ld_json: PagejsonLd,
                faq: generateFaqSchema({ faqs: match.faq }),
                created_date: match.date,
                updated_date: match.publishdate
            };
        }
    }
    else if (cleanURL.includes("/holidays-list-2025/")) {
        const match = Holidays2025data.find((item: any) => item.seo.slug === lastSegment);

        if (match) {
            seoData = {
                seo_title: match?.seo.title,
                seo_description: match?.seo.description,
                seo_keyword: match?.seo.keywords,
                og_image: siteURL + match?.seo.seoimage,
                ld_json: PagejsonLd,
                additionalldjson: match?.seo.jsonld,
                faq: generateFaqSchema({ faqs: match?.seo.faqs }),
                created_date: match?.seo.created_date,
                updated_date: match?.seo.updated_date
            };
        }
    }
    else if (cleanURL.includes("/blog/")) {
        // const res = await fetch(`${siteURL}/api/mdx-files`);
        // const apidata = await res.json();
        // const allBlogs = apidata[0].blogs;

        if (!mdxdata) {
            // const res = await fetch(`${siteURL}/api/mdx-files`);
            const res = await fetch(`${siteURL}/api/mdx-files?nocache=${Date.now()}`);
            mdxdata = await res.json();
        }

        const match = mdxdata[0].blogs.find((item: any) => item.slug === lastSegment);
        if (match) {
            seoData = {
                seo_title: match.SEO_Title,
                seo_description: match.summary,
                seo_keyword: match.tags,
                og_image: siteURL + match.ogimage,
                created_date: formatDate(match.date),
                updated_date: formatDate(match.publishdate),
                ld_json: {
                    ...PagejsonLd,
                    datePublished: formatDate(match.date),
                    dateModified: formatDate(match.publishdate),
                },
                blog: true
            };
        }
    }
    else if (segments[0]?.includes("interview-questions")) {
        // const res = await fetch(`${siteURL}/api/mdx-files`);
        // const apidata = await res.json();
        // const allInterviewQuestions = apidata[1].interviewquestions;

        if (!mdxdata) {
            const res = await fetch(`${siteURL}/api/mdx-files`);
            mdxdata = await res.json();
        }

        const match = mdxdata[1].interviewquestions.find((item: any) => item.slug === lastSegment);
        if (match) {
            seoData = {
                seo_title: match.title + " - Interview Questions",
                seo_description: match.description,
                seo_keyword: match.keywords,
                og_image: siteURL + match.ogimage,
                ld_json: PagejsonLd,
                created_date: match.created_date,
                updated_date: match.updated_date
            };
        }
    }
    else if (FullURL.includes("/top-hrms/")) {
        // const res = await fetch(`${siteURL}/api/mdx-files`);
        // const apidata = await res.json();
        // const allTopHrms = apidata[2].tophrms;

        if (!mdxdata) {
            const res = await fetch(`${siteURL}/api/mdx-files`);
            mdxdata = await res.json();
        }

        const match = mdxdata[2].tophrms.find((item: any) => item.slug === lastSegment);
        if (match) {
            seoData = {
                seo_title: match.title + " - Top HRMS",
                seo_description: match.description,
                seo_keyword: match.keywords,
                og_image: siteURL + match.image,
                ld_json: PagejsonLd,
                created_date: match.created_date,
                updated_date: match.updated_date
            };
        }
    }
    else if (cleanURL.endsWith("/alternative/")) {
        const match = Alternativedata.find((item: any) => item.seo.slug === lastSegment);
        if (match?.seo) {
            seoData = {
                seo_title: match.seo.title,
                seo_description: match.seo.description,
                seo_keyword: match.seo.keywords.join(", "),
                faq: match.seo.faq,
                og_image: siteURL + match.seo.seoimage,
                ld_json: PagejsonLd,
                created_date: match.seo.created_date,
                updated_date: match.seo.updated_date
            };
        }
    }

    // console.log("Final seoData => ", seoData);
    return seoData;
}
